import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'
import { translate } from 'react-i18next'
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const styles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
});

const SessionListActions = ({ count, page, rowsPerPage, onChangePage, theme, classes, t }) => (
  <div className={classes.root}>
    <IconButton
      onClick={e => onChangePage(e, 0)}
      disabled={page === 0}
      aria-label={t('First Page')}
    >
      {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
    </IconButton>
    <IconButton
      onClick={e => onChangePage(e, page - 1)}
      disabled={page === 0}
      aria-label={t('Previous Page')}
    >
      {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
    </IconButton>
    <IconButton
      onClick={e => onChangePage(e, page + 1)}
      disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      aria-label={t('Next Page')}
    >
      {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
    </IconButton>
    <IconButton
      onClick={e => onChangePage(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
      disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      aria-label={t('Last Page')}
    >
      {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
    </IconButton>
  </div>  
)


SessionListActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func
};

export default compose(
  translate(),
  withStyles(styles, { withTheme: true })
)(SessionListActions)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Desktop/SessionListActions.js